// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// === 1. IMPORT ALL 9 PAGES ===
import Home from './pages/Home';
import About from './pages/About'; // <-- Imported the new About page
import Overview from './pages/Overview';
import ClientView from './pages/ClientView';
import ViewInfo from './pages/ViewInfo';
import UpdateMarkers from './pages/UpdateMarkers';
import Promo from './pages/Promo';
import Admin from './pages/Admin';
import Demo from './pages/Demo';

// === 2. MAIN APP ROUTER ===
function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} /> {/* <-- Added the route */}
        <Route path='/overview' element={<Overview />} />
        <Route path='/client-view' element={<ClientView />} />
        <Route path='/view-info' element={<ViewInfo />} />
        <Route path='/update-markers' element={<UpdateMarkers />} />
        <Route path='/promo' element={<Promo />} />
        <Route path='/admin' element={<Admin />} />
        <Route path='/demo' element={<Demo />} />
      </Routes>
    </Router>
  );
}

export default App;
